<template>
  <locations />
</template>

<script>
import Locations from "@/components/3pl/Locations/index";
export default {
  components: {
    Locations,
  },
};
</script>

<style></style>
